import React from 'react';

const ChatBubble = ({ children }) => {
    return (
        children && (
            <p
                className="clx-chatbot-bubble"
                data-test-id="clx-chatbot__bubble"
                dangerouslySetInnerHTML={{ __html: children }}
            ></p>
        )
    );
};

export default ChatBubble;
